import api from 'api'
const payFeedback = {
  namespaced: true,
  state: {
    show: false,
    payment_method: '',
  },
  getters: {
    show: (state) => state.show,
  },
  mutations: {
    setShow(state, show) {
      state.show = show
    },
    setPaymentMethod(state, payment_method) {
      state.payment_method = payment_method
    },
  },
  actions: {
    show({ commit }) {
      commit('setShow', true)
    },
    hide({ commit }) {
      commit('setShow', false)
    },
    submit({ state, commit, rootGetters }, data) {
      const { fail_reason_option, other_reason } = data
      api.callOtherDomain(
        'get',
        'https://flomo.cn-shanghai.log.aliyuncs.com/logstores/pay_fail_reason/track',
        {
          APIVersion: '0.6.0',
          payment_method: state.payment_method || 'alipay',
          fail_reason: fail_reason_option || other_reason,
          user_id: rootGetters.me.id,
        },
        async (response) => {
          commit('setShow', false)
        },
      )
    },
    updatePaymentMethod({ commit }, payment_method) {
      commit('setPaymentMethod', payment_method)
    },
  },
}

export default payFeedback
